<template>
  <div class="crm-broadcasts">
    <p class="grey--text mt-4">
      Повідомлення психологам: у Telegram-бот Платформи (лише тим, хто в ньому підписаний), листом на пошту і в кабінет
      (висить на головній кабінету, доки психолог його не закриє).
    </p>

    <div class="crm-broadcasts__composer">
      <p class="font-weight-bold mb-2">Кому</p>
      <div class="crm__filters">
        <v-select v-model="audience.status" :items="statusItems" label="Статус анкети" outlined dense hide-details @change="countLater"></v-select>
        <v-checkbox v-model="audience.incomplete" label="Лише без короткого опису" hide-details dense class="mt-0" @change="countLater"></v-checkbox>
        <v-checkbox v-model="audience.noContacts" label="Лише без контактів" hide-details dense class="mt-0" @change="countLater"></v-checkbox>
        <v-checkbox v-model="audience.noPrice" label="Немає ціни" hide-details dense class="mt-0" @change="countLater"></v-checkbox>
        <v-checkbox v-model="audience.noDiplomas" label="Немає дипломів в анкеті" hide-details dense class="mt-0" @change="countLater"></v-checkbox>
        <v-checkbox v-model="audience.noVideo" label="Немає відеовізитівки" hide-details dense class="mt-0" @change="countLater"></v-checkbox>
      </div>
      <p class="crm-broadcasts__count">
        Отримають: <b>{{ counting ? "…" : count }}</b> {{ psychologistsWord(count) }}
      </p>

      <p class="font-weight-bold mb-2 mt-4">Повідомлення</p>
      <v-text-field v-model.trim="form.title" label="Заголовок" outlined dense counter="150" maxlength="150"></v-text-field>
      <v-textarea
        v-model="form.text"
        label="Текст"
        hint="{ім'я} підставить ім'я психолога. Порожній рядок = новий абзац."
        persistent-hint
        outlined
        dense
        rows="5"
        auto-grow
        counter="3000"
        maxlength="3000"
      ></v-textarea>
      <div class="crm__filters mt-4">
        <v-text-field v-model.trim="form.button_text" label="Текст кнопки (необов'язково)" outlined dense hide-details maxlength="60"></v-text-field>
        <v-text-field v-model.trim="form.button_url" label="Посилання кнопки, https://…" outlined dense hide-details maxlength="500"></v-text-field>
      </div>

      <p class="font-weight-bold mb-0 mt-4">Куди</p>
      <div class="crm-broadcasts__channels">
        <v-checkbox v-for="item in channelItems" :key="item.value" v-model="form.channels" :value="item.value" :label="item.text" hide-details dense></v-checkbox>
      </div>
      <p v-if="form.channels.includes('bot') && telegramLinked !== null" class="caption mt-2 mb-0">
        Telegram-бот Платформи підключили {{ telegramLinked }} {{ psychologistsWord(telegramLinked) }}; решті повідомлення в бот не прийде.
      </p>
      <p v-if="form.channels.includes('bot') && !botEnabled" class="caption orange--text mt-2 mb-0">
        Відправку в бот на цьому сервері ще не ввімкнено: у бот повідомлення не підуть, лише пошта і кабінет.
      </p>

      <v-btn class="mt-5" color="primary" depressed :disabled="!canSend" :loading="sending" @click="confirm = true">
        Надіслати
      </v-btn>
    </div>

    <p class="font-weight-bold mt-8 mb-2">Надіслані</p>
    <p v-if="!loading && !items.length" class="grey--text">Розсилок ще не було.</p>
    <div v-for="item in items" :key="item.id" class="crm-broadcasts__item">
      <div class="crm-broadcasts__item-head">
        <b>{{ item.title }}</b>
        <span class="caption grey--text">{{ human(item.created_at) }}</span>
      </div>
      <div class="crm-broadcasts__item-text">{{ item.text }}</div>
      <div class="caption mt-1">
        {{ audienceText(item.audience) }} · {{ item.total }} {{ psychologistsWord(item.total) }}
        <template v-if="!item.finished_at"> · надсилається: {{ item.processed }} з {{ item.total }}</template>
      </div>
      <div class="caption grey--text">
        <span v-if="item.channels.includes('bot')">у боті отримали {{ item.bot_sent }}; </span>
        <span v-if="item.channels.includes('email')">листів {{ item.email_sent }}; </span>
        <span v-if="item.channels.includes('cabinet')">закрили в кабінеті {{ item.read }}</span>
      </div>
      <div class="caption mt-1">
        <span v-if="item.edited_at" class="grey--text">виправлено {{ human(item.edited_at) }} · </span>
        <a href="#" @click.prevent="openEdit(item)">Виправити текст</a>
      </div>
    </div>

    <!-- a sent broadcast: the cabinet and the own bot's messages show the corrected text, letters cannot be changed -->
    <v-dialog v-model="edit.open" max-width="640">
      <v-card>
        <v-card-title class="crm__dialog-title">Виправити розсилку</v-card-title>
        <v-card-text>
          <p class="caption">Текст зміниться в кабінеті та в повідомленнях Telegram-бота Платформи. Листи на пошту вже не змінити.</p>
          <v-text-field v-model.trim="edit.title" label="Заголовок" outlined dense counter="150" maxlength="150"></v-text-field>
          <v-textarea v-model="edit.text" label="Текст" outlined dense rows="5" auto-grow counter="3000" maxlength="3000"></v-textarea>
          <div class="crm__filters">
            <v-text-field v-model.trim="edit.button_text" label="Текст кнопки (необов'язково)" outlined dense hide-details maxlength="60"></v-text-field>
            <v-text-field v-model.trim="edit.button_url" label="Посилання кнопки, https://…" outlined dense hide-details maxlength="500"></v-text-field>
          </div>
          <p v-if="edit.error" class="error--text caption mt-2 mb-0">{{ edit.error }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="edit.open = false">Скасувати</v-btn>
          <v-btn color="primary" depressed :loading="edit.saving" :disabled="!edit.title || !edit.text.trim()" @click="saveEdit">Зберегти</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm" max-width="440">
      <v-card>
        <v-card-title class="crm__dialog-title">Надіслати {{ count }} {{ psychologistsWord(count) }}?</v-card-title>
        <v-card-text>Скасувати після відправки не вийде.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirm = false">Ні</v-btn>
          <v-btn color="primary" depressed :loading="sending" @click="send">Так, надіслати</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import ApiClient from "@/libs/http-client";

const emptyForm = () => ({ title: "", text: "", button_text: "", button_url: "", channels: ["bot", "cabinet"] });

export default {
  name: "CrmBroadcasts",
  data() {
    return {
      items: [],
      loading: false,
      botEnabled: true,
      telegramLinked: null,
      edit: { open: false, id: null, title: "", text: "", button_text: "", button_url: "", saving: false, error: "" },
      sending: false,
      confirm: false,
      count: 0,
      counting: false,
      countTimer: null,
      audience: { status: "active", incomplete: false, noContacts: false, noPrice: false, noDiplomas: false, noVideo: false },
      form: emptyForm(),
      statusItems: [
        { value: "active", text: "Активні" },
        { value: "inactive", text: "Неактивні" },
        { value: "new", text: "Нові (не схвалені)" },
        { value: "archive", text: "Архів" },
        { value: "", text: "Усі" },
      ],
      channelItems: [
        { value: "bot", text: "Telegram-бот" },
        { value: "email", text: "Пошта" },
        { value: "cabinet", text: "Кабінет" },
      ],
    };
  },
  computed: {
    canSend() {
      return this.count > 0 && this.form.title && this.form.text.trim() && this.form.channels.length && !this.counting;
    },
  },
  mounted() {
    this.load();
    this.countRecipients();
  },
  beforeDestroy() {
    clearTimeout(this.countTimer);
  },
  methods: {
    params() {
      const params = {};
      if (this.audience.status) params.status = this.audience.status;
      if (this.audience.incomplete) params.incomplete = 1;
      if (this.audience.noContacts) params.contacts = "none";
      if (this.audience.noPrice) params.no_price = 1;
      if (this.audience.noDiplomas) params.no_diplomas = 1;
      if (this.audience.noVideo) params.no_video = 1;
      return params;
    },
    openEdit(item) {
      this.edit = {
        open: true,
        id: item.id,
        title: item.title,
        text: item.text,
        button_text: item.button_text || "",
        button_url: item.button_url || "",
        saving: false,
        error: "",
      };
    },
    saveEdit() {
      this.edit.saving = true;
      this.edit.error = "";
      ApiClient.put(`api/admin/crm/broadcasts/${this.edit.id}`, {
        title: this.edit.title,
        text: this.edit.text,
        button_text: this.edit.button_text || null,
        button_url: this.edit.button_url || null,
      })
        .then((response) => {
          if (!response) return;
          this.edit.open = false;
          this.load();
        })
        .catch((error) => {
          this.edit.error = (error && error.response && error.response.data && error.response.data.message) || "Не вдалося зберегти";
        })
        .finally(() => {
          this.edit.saving = false;
        });
    },
    load() {
      this.loading = true;
      ApiClient.get("api/admin/crm/broadcasts")
        .then((response) => {
          if (!response) return;
          this.items = response.data.data;
          this.botEnabled = response.data.bot_enabled;
          this.telegramLinked = response.data.telegram_linked;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    countLater() {
      clearTimeout(this.countTimer);
      this.countTimer = setTimeout(this.countRecipients, 300);
    },
    countRecipients() {
      this.counting = true;
      ApiClient.get("api/admin/crm/psychologists", { params: { ...this.params(), per_page: 10 } })
        .then((response) => {
          if (response) this.count = response.data.meta.total;
        })
        .finally(() => {
          this.counting = false;
        });
    },
    send() {
      this.sending = true;
      const body = { ...this.form };
      if (!body.button_url) delete body.button_url;
      if (!body.button_text) delete body.button_text;
      // the CRM filters go in the query, the same as the psychologists list
      const query = new URLSearchParams(this.params()).toString();
      ApiClient.post("api/admin/crm/broadcasts" + (query ? "?" + query : ""), body)
        .then((response) => {
          if (!response) return;
          this.confirm = false;
          this.form = emptyForm();
          Vue.swal({ target: document.getElementById("main"), text: `Розсилку створено: ${response.data.data.total}`, icon: "success", timer: 3000, toast: true, position: "top-right", showConfirmButton: false });
          this.load();
        })
        .catch((error) => {
          Vue.swal({ target: document.getElementById("main"), text: (error && error.message) || "Не вдалося створити розсилку", icon: "error", timer: 6000, toast: true, position: "top-right", showConfirmButton: false });
        })
        .finally(() => {
          this.sending = false;
        });
    },
    psychologistsWord(count) {
      const tens = count % 100;
      const last = count % 10;
      if (tens >= 11 && tens <= 14) return "психологів";
      if (last === 1) return "психолог";
      if (last >= 2 && last <= 4) return "психологи";
      return "психологів";
    },
    audienceText(audience) {
      // "Написати психологу" from the CRM card
      if (audience && audience.profile) return "особисте повідомлення";
      const parts = [];
      const status = this.statusItems.find((item) => item.value === ((audience || {}).status || ""));
      parts.push(status ? status.text : "Усі");
      if (audience && audience.incomplete) parts.push("без короткого опису");
      if (audience && audience.contacts === "none") parts.push("без контактів");
      if (audience && audience.no_price) parts.push("без ціни");
      if (audience && audience.no_diplomas) parts.push("без дипломів в анкеті");
      if (audience && audience.no_video) parts.push("без відеовізитівки");
      if (audience && audience.search) parts.push(`пошук «${audience.search}»`);
      return parts.join(", ");
    },
    human(value) {
      return value ? new Date(value).toLocaleString("uk-UA") : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-broadcasts__composer {
  max-width: 760px;
}
.crm-broadcasts__count {
  margin: 12px 0 0;
}
.crm-broadcasts__channels {
  display: flex;
  flex-wrap: wrap;
  gap: 0 24px;
}
.crm-broadcasts__item {
  max-width: 760px;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
}
.crm-broadcasts__item-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
}
.crm-broadcasts__item-text {
  margin-top: 4px;
  white-space: pre-line;
}
</style>
